import ChannelTitle from "discourse/plugins/chat/discourse/components/channel-title";

const OldChatChannelTitle = <template>
  <ChannelTitle @channel={{@channel}} />
</template>;

export default OldChatChannelTitle;
